import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User opened edit person modal',
  name: 'updated_people_sort',
  params: [
    {
      description: 'Sort field',
      name: 'sort_field',
      required: true,
      type: 'enum',
      values: ['first_name', 'last_name', 'created_at'],
    },
    {
      description: 'Sort direction',
      name: 'sort_direction',
      required: true,
      type: 'enum',
      values: ['asc', 'desc'],
    },
  ],
};

export default META;
